import styled from "styled-components";
import CONSTANT from "../../constants/constant";

const SearchContainer = styled.div`
  width: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "100%" : "50%"};
  height: 100%;
  min-height: 100%;
`;

const Icon = styled.div`
  position: absolute;
  right: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "20px" : "19px"};
  top: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "9px" : "12px"};
  bottom: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "20px" : "18px"};
  width: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "22px" : props.width || "30px"};
  height: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "22px" : props.height || "30px"};
`;

const IconContainer = styled.button`
  position: relative;
  height: 100%;
  min-height: 100%;
  border-radius: 0px 40px 40px 0px;
  padding: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "15px 16px" : "15px 32px"};
  border: 1px solid ${({ theme }) => theme.colors.grey};
  border-left: none;
  width: 60px;
  cursor: pointer;
  transition: 0.5s;

  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    svg,
    path {
      fill: white;
    }
  }
`;

export { SearchContainer, Icon, IconContainer };
